import React from "react";
import styled from "styled-components";
import { FaStar, FaRegStar } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { translations } from "../../utils/translations";

const RatingContainer = styled.div<{ $isVertical?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${({ $isVertical }) => ($isVertical ? "column" : "row")};
  gap: 4px;
  padding: ${({ $isVertical }) => ($isVertical ? "16px" : "0")};

  width: 10%;
`;
const StarsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
const StarsNumber = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: var(--primary-brown);
`;

const RatingsNumber = styled.div`
  font-size: 14px;
  color: var(--primary-brown);
  text-wrap: nowrap;
`;

interface Props {
  rating: number;
  isVertical?: boolean;
  reviewsNumber?: number;
}

const ReviewStars: React.FC<Props> = ({
  rating,
  isVertical,
  reviewsNumber,
}) => {
  const languageCode = useSelector((state: any) => state.settings.languageCode);
  return (
    <RatingContainer $isVertical={isVertical}>
      <StarsNumber>{rating} </StarsNumber>
      <StarsContainer>
        {Array.from({ length: 5 }).map((_, index) =>
          index < rating ? (
            <FaStar key={index} style={{ fill: "var(--primary-brown)" }} />
          ) : (
            <FaRegStar key={index} style={{ fill: "var(--primary-brown)" }} />
          )
        )}
      </StarsContainer>
      {reviewsNumber !== undefined && (
        <RatingsNumber>
          {reviewsNumber} {translations[languageCode]["rating-number"]}
        </RatingsNumber>
      )}
    </RatingContainer>
  );
};

export default ReviewStars;
